<template>
    <v-card>
        <v-card-title>{{ round.name }}</v-card-title>
        <v-card-text>
            <v-layout>
                <v-flex xs6><app-item-label>Nombre</app-item-label></v-flex>
                <v-flex xs6>{{ round.name }}</v-flex>
            </v-layout>
            <v-layout column>
                <v-flex><app-item-label>Días de operación</app-item-label></v-flex>
                <v-flex>
                    <v-chip :title="getDayLabel(day.day)" text-color="white" size="sm" color="primary" mr-1 v-for="day in round.days" :key="day.day">
                        {{ getDay(day.day) }}
                    </v-chip>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs6><app-item-label>Franja de operación</app-item-label></v-flex>
                <v-flex xs6>{{ round.start_hour }} - {{ round.end_hour }}</v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs6><app-item-label>Puntos de control</app-item-label></v-flex>
                <v-flex xs6>{{ round.control_points.length }}</v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs6><app-item-label>Lista de chequeo</app-item-label></v-flex>
                <v-flex xs6>{{ round.check_list.length }}</v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs6><app-item-label>Duración</app-item-label></v-flex>
                <v-flex xs6>{{ round.duration }} H</v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" block @click="startRound(round)"> Iniciar {{ round.name }} </v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
    props: {
        round: {
            type: Object,
            required: true
        }
    },
    methods: {
        getDay(day) {
            const days = {
                0: 'd',
                1: 'l',
                2: 'm',
                3: 'm',
                4: 'j',
                5: 'v',
                6: 's',
            }

            return days[day];
        },
        getDayLabel(day) {
            const days = {
                0: 'Domingo',
                1: 'Lunes',
                2: 'Martes',
                3: 'Miercoles',
                4: 'Jueves',
                5: 'Viernes',
                6: 'Sábado',
            }

            return days[day];
        },
        startRound(round) {
            this.$emit('start', round);
        }
    }
}
</script>
